const ScreenHeader = (props) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 55,
        zIndex: 100000,
        backgroundColor: "#505659",
        color: "#eee",
      }}
    >
      {props.children}
    </div>
  );
};

export default ScreenHeader;
